import { Layout } from 'antd'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import DashboardPage from './components/dashboard/DashboardPage'
import GiftRequestsPage from './components/gift-requests/GiftRequestsPage'
import EditGiftPage from './components/gifts/EditGiftPage'
import GiftPage from './components/gifts/GiftPage'
import NewGiftPage from './components/gifts/NewGiftPage'
import SettingsPage from './components/settings/SettingsPage'
import TransfersPage from './components/transfers/TransfersPage'
import UsersPage from './components/users/UsersPage'
import FooterLayout from './layout/FooterLayout'
import HeaderLayout from './layout/HeaderLayout'
import SidebarLayout from './layout/SidebarLayout'
import './scss/main.css'
import StatisticalsPage from './components/statistical/StatisticalPage'
import UserTopPage from './components/tops/UserTopPage'
import UserTopDetailPage from './components/tops/UserTopDetailPage'
import StatisticsPage from './components/statistics/StatisticsPage'
const { Content } = Layout

const DashboardApp: React.FC = () => {
  return (
    <Layout className="app-container">
      <SidebarLayout />
      <Layout>
        <HeaderLayout />
        <Content className="content-container">
          <Routes>
            <Route
              path='/dashboard'
              element={<DashboardPage />}
            />
            <Route
              path="/gifts/requests"
              element={<GiftRequestsPage />}
            />
            <Route
              path="/gifts"
              element={<GiftPage />}
            />
            <Route
              path="/settings"
              element={<SettingsPage />}
            />
            <Route
              path="/gifts/new"
              element={<NewGiftPage />}
            />
            <Route
              path="/gifts/:id"
              element={<EditGiftPage />}
            />
            <Route
              path="/transfers"
              element={<TransfersPage />}
            />
            <Route
              path="/team"
              element={<UsersPage />}
            />
            <Route
              path="/statisticals"
              element={<StatisticalsPage />}
            />
            <Route
              path="/users/top"
              element={<UserTopPage />}
            />
             <Route
              path="/users/top/detail"
              element={<UserTopDetailPage />}
            />
            <Route
              path="/users/statistics"
              element={<StatisticsPage />}
            />
          </Routes>
        </Content>
        <FooterLayout />
      </Layout>
    </Layout>
  )
}

export default DashboardApp
